import { IconSettings } from "@tabler/icons-react";
import { getFullName } from "@utils/lib/getFullname";
import s from "../video-conf.module.scss";
import { TextWithEmoji } from "@shared/ui/text-with-emoji/text-with-emoji";

export const LessonInfo = ({ appointment, isTeacher, onOpenSoundTest, onConnect, disabled }) => {
  const person = isTeacher ? appointment?.student : appointment?.teacher;
  const personName = person ? getFullName(person) : "Будет указан позже";
  const instrument = appointment?.instrument?.name || "";

  return (
    <>
      <div className={s.metaList}>
        <div className={s.metaItem}>
					<div className={s.profileWrapper}>
						<div className={s.avatarWrapper}>
							<img
									src={
										person?.avatar
											? process.env.REACT_APP_STORAGE_URL + person?.avatar.image
											: process.env.REACT_APP_STORAGE_URL + "images/default_avatar.png"
									}
									className={s.avatarImage}
									alt=""
								/>
						</div>
						<div className={s.profileContent}>
							<span className={s.profileName}>{personName}</span>
							<span className={s.profileInstrument}><TextWithEmoji text={instrument}/></span>
						</div>
					</div>
        </div>

        <div className={s.metaItem}>
          <div className={s.metaLabel}>Совет:</div>
          <div className={s.metaValue}>
						<strong className={s.accentText}>Проверьте звук, камеру и инструмент</strong>, чтобы не тратить время на настройку. <br/><br/>
						<strong className={s.accentText}>Убедитесь, что интернет стабильный</strong> - лучше Wi-Fi или кабель. <br/><br/>
						<strong className={s.accentText}>Используйте наушники</strong>, чтобы избежать эха, и <strong className={s.accentText}>отключите шумоподавление и «улучшения звука»</strong>, чтобы не искажался звук инструмента.
					</div>
        </div>
      </div>



      <div className={s.metaActions}>
        <button type="button" className={s.settingsButton} onClick={onOpenSoundTest}>
          <IconSettings size={16} />
          Настройки конференции
        </button>
        <button type="button" disabled={disabled} className={s.connectButton} onClick={onConnect}>
          Подключиться
        </button>
				<small className={s.connectCaptions}>
					Подключиться к уроку можно <br/> будет за 10 минут
				</small>
      </div>
    </>
  );
};
